import React from "react";
import pendientesB from "assets/img/bn/acciones_pendientes2.png";
import revisionB from "assets/img/bn/revision2.png";
import analisiB from "assets/img/bn/analisis2.png";
import respuestaB from "assets/img/bn/respuesta2.png";

import pendientesC from "assets/img/color/acciones_pendientes.png";
import revisionC from "assets/img/color/revision.png";
import analisiC from "assets/img/color/analisis.png";
import respuestaC from "assets/img/color/respuesta.png";

import subirS from "assets/img/colorSin/subirS.png";
import revisionS from "assets/img/colorSin/revisionS.png";
import analisiS from "assets/img/colorSin/analisisS.png";
import respuestaS from "assets/img/colorSin/respuestaS.png";
import pendientesS from "assets/img/colorSin/pendientesS.png";

import base from "assets/img/color/base.png";
import grdS from "assets/img/color/gradas_subir.png";
import grdB from "assets/img/color/gradas_bajar.png";
import { ModalUploadDocs } from "../../sec/ModalUploadDocs";
import { useToggle } from "../../custom-hooks/customs";
import { getDatosDoc } from "../../gen/siniestros/utils";

export const SvgInfo = ({
    paso1,
    paso2,
    paso3,
    paso4,
    paso5,
    paso6,
    fechaFormato,
    setViewG,
    setViewS,
    setViewM,
    modal,
    zohoFormItem,
    setInstrucciones,
    ...props
}) => {
    let active = "active";
    let current = "current";
    let marginTop = paso6.paso ? 130 : 0;

    const { open, toggleOpen } = useToggle();
    const { tipo, dato, onClose } = props;

    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1088"
                height="708"
                viewBox="0 0 1088 708"
                style={{ width: "100%", marginTop }}
            >
                <g id="Grupo_1910" data-name="Grupo 1910" transform="translate(4721 -4191)">
                    <g
                        className={`item c-pointer ${paso1.ultimo ? current : ""} ${paso1.paso ? active : ""}`}
                        onClick={() => {
                            if (dato?.zohoId) {
                                toggleOpen();
                            } else if (modal) {
                                setViewM(true);
                            } else {
                                setViewG(false);
                                setViewS(true);
                            }
                            setInstrucciones && setInstrucciones(true);
                        }}
                    >
                        <image
                            href={base}
                            id="base"
                            className="cls-1"
                            width="208"
                            height="135"
                            transform="translate(-4695 4764)"
                        />
                        <g transform="translate(-4721 4569)">
                            <image href={subirS} id="subir_documentos" width="260" height="300" className={"step"} />
                        </g>
                        <g transform="translate(-4560 4579)">
                            {paso1.fechas.map((s, index) => (
                                <text transform={`translate(0 ${20 * index})`} key={index + s}>
                                    {fechaFormato(s)}
                                </text>
                            ))}
                        </g>
                    </g>

                    <g className={`item ${paso2.ultimo ? current : ""} ${paso2.paso ? active : ""}`}>
                        <image
                            href={base}
                            id="base-5"
                            data-name="base"
                            className="cls-1"
                            width="208"
                            height="135"
                            transform="translate(-4419 4575)"
                        />
                        <g transform="translate(-4445.968 4392.5)">
                            <image
                                href={paso2.paso ? (paso2.ultimo ? revisionC : revisionS) : revisionB}
                                id="revision"
                                width="260"
                                height="289.5"
                                className={"step"}
                            />
                        </g>

                        <image
                            href={grdS}
                            id="gradas_subir-2"
                            data-name="gradas_subir"
                            transform="translate(-4508.845 4656.75)"
                            width="125.5"
                            height="73"
                        />
                        <g transform="translate(-4335.968 4400.5)">
                            {paso2.fechas.map((s, index) => (
                                <text transform={`translate(0 ${20 * index})`} key={index + s}>
                                    {fechaFormato(s)}
                                </text>
                            ))}
                        </g>
                    </g>

                    <g className={`item ${paso3.ultimo ? current : ""} ${paso3.paso ? active : ""}`}>
                        <image
                            href={base}
                            id="base-2"
                            data-name="base"
                            className="cls-1"
                            width="208"
                            height="135"
                            transform="translate(-4143 4764)"
                        />
                        <g transform="translate(-4169 4590.5)">
                            <image
                                href={paso3.paso ? (paso3.ultimo ? analisiC : analisiS) : analisiB}
                                id="analisis"
                                width="260"
                                height="278.5"
                                className={"step"}
                            />
                        </g>
                        <image
                            href={grdB}
                            id="gradas_bajar-2"
                            data-name="gradas_bajar"
                            className="cls-2"
                            width="122"
                            height="73"
                            transform="translate(-4234 4668)"
                        />
                        <g transform="translate(-4065 4600.5)">
                            {paso3.fechas.map((s, index) => (
                                <text transform={`translate(0 ${20 * index})`} key={index + s}>
                                    {fechaFormato(s)}
                                </text>
                            ))}
                        </g>
                    </g>

                    <g className={`item ${paso4.ultimo ? current : ""} ${paso4.paso ? active : ""}`}>
                        <image
                            href={base}
                            id="base-6"
                            data-name="base"
                            className="cls-1"
                            width="208"
                            height="135"
                            transform="translate(-3867 4575)"
                        />
                        <g transform="translate(-3893 4388)">
                            <image
                                href={paso4.paso ? (paso4.ultimo ? respuestaC : respuestaS) : respuestaB}
                                id="respuesta"
                                width="260"
                                height="294"
                                className={"step"}
                            />
                        </g>
                        <image
                            href={grdS}
                            id="gradas_subir"
                            transform="translate(-3965.5 4665.834)"
                            width="125.5"
                            height="73"
                        />
                        <g transform="translate(-3763 4397.5)">
                            {paso4.fechas.map((s, index) => (
                                <text transform={`translate(0 ${20 * index})`} key={index + s}>
                                    {fechaFormato(s)}
                                </text>
                            ))}
                        </g>
                    </g>

                    {paso5.paso && (
                        <g className={`item ${paso5.ultimo ? current : ""} ${paso5.paso ? active : ""}`}>
                            <image
                                href={base}
                                id="base-4"
                                data-name="base"
                                className="cls-1"
                                width="208"
                                height="135"
                                transform="translate(-4695 4388)"
                            />
                            <image
                                href={grdB}
                                id="gradas_bajar-3"
                                data-name="gradas_bajar"
                                className="cls-2"
                                width="122"
                                height="73"
                                transform="translate(-4515 4483)"
                            />
                            <g transform="translate(-4721 4191)">
                                <image
                                    href={paso5.paso ? (paso5.ultimo ? pendientesC : pendientesS) : pendientesB}
                                    id="acciones_pertinentes"
                                    width="260"
                                    height="305"
                                    className={"step"}
                                />
                            </g>
                            <g transform="translate(-4574 4204.5)">
                                {paso5.fechas.map((s, index) => (
                                    <text transform={`translate(0 ${20 * index})`} key={index + s}>
                                        {fechaFormato(s)}
                                    </text>
                                ))}
                            </g>
                        </g>
                    )}

                    {paso6.paso && (
                        <g className={`item ${paso6.ultimo ? current : ""} ${paso6.paso ? active : ""}`}>
                            <image
                                href={base}
                                id="base-3"
                                data-name="base"
                                className="cls-1"
                                width="208"
                                height="135"
                                transform="translate(-4143 4388)"
                            />
                            <g transform="translate(-4169 4191)">
                                <image
                                    href={paso6.paso ? (paso6.ultimo ? pendientesC : pendientesS) : pendientesB}
                                    id="acciones_pertinentes-2"
                                    data-name="acciones_pertinentes"
                                    width="260"
                                    height="305"
                                    className={"step"}
                                />
                            </g>
                            <image
                                href={grdB}
                                id="gradas_bajar"
                                className="cls-2"
                                width="122"
                                height="73"
                                transform="translate(-3961 4481)"
                            />
                            <g transform="translate(-4021 4204.5)">
                                {paso6.fechas.map((s, index) => (
                                    <text transform={`translate(0 ${20 * index})`} key={index + s}>
                                        {fechaFormato(s)}
                                    </text>
                                ))}
                            </g>
                        </g>
                    )}
                </g>
            </svg>
            {tipo && dato && onClose && (
                <ModalUploadDocs
                    open={open}
                    toggleModal={toggleOpen}
                    datos={getDatosDoc(tipo, dato)}
                    onClose={onClose}
                />
            )}
        </>
    );
};
